import React from 'react';
import PropTypes from 'prop-types';
import styles from '../hiwTemplate.module.scss';

export default function HiwControls({ onLeftClick, onRightClick }) {
  return (
    <>
      <button
        aria-label="Go left"
        onClick={onLeftClick}
        className={`${styles.hiwTemplateControl} ${styles.hiwTemplateControlLeft} `}
        type="submit"
        data-testid="hiw-template-control-left"
      />
      <button
        aria-label="Go right"
        onClick={onRightClick}
        className={`${styles.hiwTemplateControl} ${styles.hiwTemplateControlRight} `}
        type="submit"
        data-testid="hiw-template-control-right"
      />
    </>
  );
}

HiwControls.propTypes = {
  onLeftClick: PropTypes.func.isRequired,
  onRightClick: PropTypes.func.isRequired,
};
